export const formatBytes = (sz) => {
  if (!sz) return ''
  if (sz < 1024) return sz + ' B'
  if (sz < 1024 * 1024) return Math.round(sz / 1024) + ' KB'
  return Math.round(sz / 1024 / 1024) + ' MB'
}
